'use client';

import { useFrontasticBridgeReduxLayoutDispatches } from '../../redux/useFrontasticBridgeReduxDispatches';
import injection from '@apgnext/project/legacy/js/injection';

// we have to call this function so the import won't be optimized away.
injection();

interface Props {
  // @COFIXME[low-prio]: fix this type
  contextData: any;
  userAgent: string;
}

export const CatwalkLayoutProvider: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  contextData,
  userAgent,
}) => {
  useFrontasticBridgeReduxLayoutDispatches(contextData.locale, userAgent, contextData);

  return <>{children}</>;
};
